import apiClient from '../../api/axios';

/* ===========================
   Interfaces
=========================== */

export interface OrganizationType {
  id: string;
  title: string;
  description: string;
}

export interface ValidateLicensePayload {
  licenseKey: string;
}

export interface CreateOrganizationPayload {
  title: string;
  description: string;
  parentOrganizationId: string | null;
  organizationTypeId: string;
  licenseKey: string;
  vision: string;
  mission: string;
  employeeCount: number;
  branchCount: number;
  establishDate: string;
  phone: string;
  email: string;
  address: string;
  website: string;
  sourceLanguageId: string | null;
}

/* ===========================
   GET Organization Types
   GET /installations/organization-types
=========================== */

export const getOrganizationTypes = async () => {
  const response = await apiClient.get('/installations/organization-types');

  return response.data;
};

/* ===========================
   POST Validate License
   POST /licenses/validate
=========================== */

export const validateLicense = async (data: ValidateLicensePayload) => {
  const response = await apiClient.post('/licenses/validate', data);

  return response.data;
};

/* ===========================
   POST Create Organization
   POST /installations/organizations
=========================== */

export const createOrganization = async (data: CreateOrganizationPayload) => {
  const response = await apiClient.post('/installations/organizations', data);

  return response.data;
};
